package org.molap.dataframe

fun <R, C, O> DataFrame<R, C, Any?>.toList(
    transform: DataFrame<R, C, Any?>.(R) -> O
): List<O> {
    return rows().map { row ->
        transform(row) // `this` refers to the DataFrame
    }
}
